module.exports = __webpack_public_path__ + "img/logo-group1-1.90239f08.svg";